import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SendIcon, PhoneIcon, MailIcon, MapPinIcon, ClockIcon, MessageCircleIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function ContactsPage() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    alert('Дякуємо! Ваше повідомлення відправлено.');
    setFormData({
      name: '',
      phone: '',
      email: '',
      message: ''
    });
  };
  const contactInfo = [{
    icon: PhoneIcon,
    title: 'Телефон',
    value: '+38 (067) 123-45-67',
    link: 'tel:+380671234567',
    action: 'Зателефонувати'
  }, {
    icon: SendIcon,
    title: 'Telegram',
    value: '@aquapools_if',
    link: 'https://t.me/aquapools_if',
    action: 'Написати'
  }, {
    icon: MailIcon,
    title: 'Email',
    value: 'sales@aquapools.ua',
    link: 'mailto:sales@aquapools.ua',
    action: 'Написати'
  }, {
    icon: MapPinIcon,
    title: 'Адреса',
    value: 'м. Івано-Франківськ, Україна',
    link: 'https://maps.google.com',
    action: 'Показати на карті'
  }];
  return <main className="min-h-screen bg-slate-50" data-id="element-658">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-659">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-660">
          <nav className="flex items-center gap-2 text-sm" data-id="element-661">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-662">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-663">/</span>
            <span className="text-slate-900 font-medium" data-id="element-664">Контакти</span>
          </nav>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-665">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-666">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-667">Контакти</h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-668">
            Зв'яжіться з нами будь-яким зручним способом. Ми завжди раді
            допомогти!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12" data-id="element-669">
          {/* Contact Info Cards */}
          {contactInfo.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center text-center" data-id="element-670">
              <div className="w-14 h-14 bg-sky-100 rounded-full flex items-center justify-center mb-4" data-id="element-671">
                <item.icon className="w-7 h-7 text-sky-600" data-id="element-672" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-1" data-id="element-673">
                {item.title}
              </h3>
              <p className="text-slate-600 mb-4" data-id="element-674">{item.value}</p>
              <a href={item.link} target="_blank" rel="noopener noreferrer" className="mt-auto" data-id="element-675">
                <Button variant="outline" size="sm" data-id="element-676">
                  {item.action}
                </Button>
              </a>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-677">
          {/* Map & Schedule */}
          <div className="space-y-8" data-id="element-678">
            {/* Schedule */}
            <div className="bg-white rounded-2xl shadow-md p-6" data-id="element-679">
              <div className="flex items-center gap-3 mb-6" data-id="element-680">
                <div className="w-10 h-10 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-681">
                  <ClockIcon className="w-5 h-5 text-sky-600" data-id="element-682" />
                </div>
                <h2 className="text-xl font-bold text-slate-900" data-id="element-683">
                  Графік роботи
                </h2>
              </div>
              <div className="space-y-3" data-id="element-684">
                <div className="flex justify-between items-center py-2 border-b border-slate-100" data-id="element-685">
                  <span className="text-slate-600" data-id="element-686">Понеділок - П'ятниця</span>
                  <span className="font-medium text-slate-900" data-id="element-687">
                    09:00 - 18:00
                  </span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-slate-100" data-id="element-688">
                  <span className="text-slate-600" data-id="element-689">Субота</span>
                  <span className="font-medium text-slate-900" data-id="element-690">
                    10:00 - 15:00
                  </span>
                </div>
                <div className="flex justify-between items-center py-2" data-id="element-691">
                  <span className="text-slate-600" data-id="element-692">Неділя</span>
                  <span className="font-medium text-slate-400" data-id="element-693">Вихідний</span>
                </div>
              </div>
            </div>

            {/* Map Placeholder */}
            <div className="bg-slate-200 rounded-2xl h-80 relative overflow-hidden group" data-id="element-694">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-695">
                <div className="text-center" data-id="element-696">
                  <MapPinIcon className="w-12 h-12 text-slate-400 mx-auto mb-2" data-id="element-697" />
                  <p className="text-slate-500 font-medium" data-id="element-698">
                    Карта завантажується...
                  </p>
                </div>
              </div>
              {/* Overlay for demo */}
              <div className="absolute inset-0 bg-slate-900/5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-699">
                <Button variant="secondary" data-id="element-700">Відкрити в Google Maps</Button>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-md p-6 lg:p-8" data-id="element-701">
            <div className="flex items-center gap-3 mb-6" data-id="element-702">
              <div className="w-10 h-10 bg-sky-100 rounded-xl flex items-center justify-center" data-id="element-703">
                <MessageCircleIcon className="w-5 h-5 text-sky-600" data-id="element-704" />
              </div>
              <h2 className="text-xl font-bold text-slate-900" data-id="element-705">Напишіть нам</h2>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-706">
              <Input label="Ваше ім'я" value={formData.name} onChange={e => setFormData({
              ...formData,
              name: e.target.value
            })} placeholder="Іван Петров" required data-id="element-707" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-708">
                <Input label="Телефон" type="tel" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} placeholder="+38 (0__) ___-__-__" required data-id="element-709" />
                <Input label="Email" type="email" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} placeholder="email@example.com" required data-id="element-710" />
              </div>
              <div data-id="element-711">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-712">
                  Повідомлення
                </label>
                <textarea value={formData.message} onChange={e => setFormData({
                ...formData,
                message: e.target.value
              })} placeholder="Ваше запитання..." rows={5} className="w-full px-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent resize-none" required data-id="element-713" />
              </div>
              <Button type="submit" size="lg" fullWidth data-id="element-714">
                Надіслати повідомлення
              </Button>
            </form>
          </div>
        </div>
      </div>
    </main>;
}